/*
 * Load various JavaScript modules that assist Spark.
 */
window.URI = require('urijs');
window.axios = require('axios');
window._ = require('lodash');
window.moment = require('moment');
window.Promise = require('promise');
window.__ = (key, replace) => {
    let translation = Spark.translations[key] ? Spark.translations[key] : key;

    _.forEach(replace, (value, key) => {
        translation = translation.replace(':'+key, value);
    });

    return translation;
};

/*
 * Define Moment locales
 */
window.moment.defineLocale('en-short', {
    parentLocale: 'en',
    relativeTime : {
        future: "in %s",
        past:   "%s",
        s:  "1s",
        m:  "1m",
        mm: "%dm",
        h:  "1h",
        hh: "%dh",
        d:  "1d",
        dd: "%dd",
        M:  "1 month ago",
        MM: "%d months ago",
        y:  "1y",
        yy: "%dy"
    }
});
window.moment.locale('en');

/*
 * Load jQuery used for front-end interaction.
 */
if (window.$ === undefined || window.jQuery === undefined) {
    window.$ = window.jQuery = require('jquery');
}

/**
 * Load Popper.JS for front-end interaction.
 */
window.Popper = require('popper.js').default;

/*
 * Load Bootstrap, used for front-end interaction.
 */
if (window.bootstrap === undefined) {
    window.bootstrap = require('bootstrap');
}

/**
 * Load Vue if this application is using Vue as its framework.
 */
if ($('#spark-app').length > 0) {
    require('vue-bootstrap');
}

/**
 * Load Tooltip Plugin for correct work bootstrap tooltips.
 */
if (window.Vue !== undefined) {
    window.Vue.use({
        install(Vue, options) {
            Vue.mixin({
                updated() {
                    this.$nextTick(() => {
                        if ($('[data-bs-toggle="tooltip"]').length && typeof $.fn.tooltip === "function") {
                            $('[data-bs-toggle="tooltip"]').tooltip({
                                trigger : 'hover'
                            }).click(function (){
                                if($('.bs-tooltip-auto')) {
                                    $('.bs-tooltip-auto').remove();
                                }
                            });
                        }

                        if ($('[data-tooltip-html="true"]').length && typeof $.fn.tooltip === "function") {
                            $('[data-tooltip-html="true"]').tooltip({html:true});
                        }
                    });
                }
            });
        }
    });
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': Spark.csrfToken
};

/**
 * Intercept the incoming responses.
 *
 * Handle any unexpected HTTP errors and pop up modals, etc.
 */
window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response === undefined) {
        return Promise.reject(error);
    }

    switch (error.response.status) {
        case 401:
        case 419:
            $('#modal-session-expired').modal('show');
            break;

        case 402:
            window.location = '/settings#/subscription';
            break;
    }

    return Promise.reject(error);
});
